
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class BackgroundLoader extends Vue {
  @Prop() source!: string | null;
  @Prop() folder!: string | null;

  // mounted() {
  //   console.log("BackgroundLoader mounted");
  // }

  get bgName() {
    return this.folder ? this.folder + "/" + this.source : this.source;
  }

  get bgImage() {
    return require("@/assets/" + this.bgName);
  }

  get mainStyle() {
    // console.log("mainStyle - " + this.bgImage);
    if (!this.source) return "{}"
    return {
      backgroundImage: `url(${this.bgImage})`,
    };
  }

  // @Watch("source")
  // onSourceChanged(newValue: string) {
  //   console.log("Source changed: ", newValue);
  // }
}
